import axios from 'axios';

export const fetchImage = async ({ endpoint, accessToken, customerToken }) => {
  const response = await axios.get(endpoint, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Customer-Token': customerToken
    },
    responseType: 'blob'
  });

  const blob = new Blob([response.data], { type: 'application/octet-stream' });

  return blob;
};
